import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import { Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { CompanyService } from "../../services/company.service";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Company } from "../../data-types/company.interface";
@Component({
  selector: "company-plus-core-company-info",
  templateUrl: "./company-plus-info.component.html",
  styleUrls: ["./company-plus-info.component.scss"],
})
export class CompanyPlusInfoComponent implements OnInit, OnDestroy {
  @Input("form") form: FormGroup;
  @Output("location") location = new EventEmitter();
  public EInputStyleType = EInputStyleType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public EButtonType = EButtonType;
  public ETextareaStyleType = ETextareaStyleType;
  public endGetInfo = false;
  public companyId;
  public daysOfWeek = [
    this.translate.instant("coworking.general.monday"),
    this.translate.instant("coworking.general.tuesday"),
    this.translate.instant("coworking.general.wednesday"),
    this.translate.instant("coworking.general.thursday"),
    this.translate.instant("coworking.general.friday"),
    this.translate.instant("coworking.general.saturday"),
    this.translate.instant("coworking.general.sunday"),
  ];
  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private companyService: CompanyService,
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  async ngOnInit() {
    this.companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    // EDIT compamny
    if (this.companyId && this.isEditingInfo) {
      try {
        this._store.dispatch(showLoadingAction({}));
        const response = await this.companyService.getCompanyInfo(
          this.companyId
        );
        console.log("response:", response);
        if (response.business_group) {
          this.form.get("is_business_group").disable();
          // this.form.get("is_business_group").;
          this.form.get("business_group").setValue(response.business_group);
          this.form.get("business_group").disable();
        }

        this.form.patchValue({
          is_business_group: response.business_group ? "SÃ­" : "No",
        });
        this.form.get("email").disable();
        if (response.image) {
          this.form.patchValue({
            file: response.image,
          });
        } else {
          this.form.patchValue({
            file: "qwert",
          });
        }
        this.form.patchValue(response);
        this.setHours(response);
        this.setMedia(response);

        // this.form.markAllAsTouched();
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this.endGetInfo = true;
        this._store.dispatch(closeLoadingAction({}));
      }
      // CREATING NEW ONE FROM USERPANEL
    } else if (this.companyId && !this.isEditingInfo) {
      this._store.dispatch(showLoadingAction({}));
      const response = await this.companyService.getCompanyInfo(this.companyId);
      // this.form.get("email").setValue(response.email);
      this.form.get("email").disable();
      if (!response.business_group) {
        this.form.patchValue({
          is_business_group: "SÃ­",
        });
        this.form.get("is_business_group").disable();
        this.form.get("business_group").enable();
        this.form.get("business_group").setValidators(Validators.required);
      } else {
        this.form.patchValue({
          is_business_group: "SÃ­",
        });
        this.form.get("business_group").setValue(response.business_group);
        this.form.get("is_business_group").disable();
        this.form.get("business_group").disable();
      }
      this.endGetInfo = true;
      this._store.dispatch(closeLoadingAction({}));
      // CREATING NEW FROM REGISTRATION FUNNEL
    } else {
      this.endGetInfo = true;
    }

    this.form.get("is_business_group").valueChanges.subscribe((value) => {
      if (
        (this.endGetInfo && !this.companyId) ||
        (this.endGetInfo && this.companyId && this.isEditingInfo)
      ) {
        const businessGroupName = this.form.get("business_group");
        if (value === "No" && businessGroupName.disabled === false) {
          businessGroupName.setValidators([]);
          businessGroupName.disable();
          businessGroupName.setValue("");
        } else if (value === "SÃ­" && businessGroupName.disabled === true) {
          businessGroupName.setValidators([Validators.required]);
          businessGroupName.enable();
        }

        businessGroupName.updateValueAndValidity();
      }
    });
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  public get isEditingInfo() {
    return this.router.url === "/company-info" ? true : false;
  }
  public setLocation(currentLocation) {
    !this.isEditingInfo
      ? this.location.emit(currentLocation)
      : this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    this.form.get("latitude").setValue(location.lat);
    this.form.get("longitude").setValue(location.lng);
    this.form.get("city").setValue(location.city);
    this.form.get("country").setValue(location.country);
    this.form.get("province").setValue(location.province);
  }
  public goBack() {
    this.router.navigate(["company-home"]);
  }
  public get isDisabledForm() {
    return this.form.dirty && this.form.valid ? false : true;
  }

  private formGeneralInfoData() {
    const form = this.form.getRawValue();
    let formattedForm: any = new Company(form);
    formattedForm.hours = [
      {
        day: 0,
        end: form.schedule_close_1,
        start: form.schedule_open_1,
      },
      {
        day: 1,
        end: form.schedule_close_2,
        start: form.schedule_open_2,
      },
      {
        day: 2,
        end: form.schedule_close_3,
        start: form.schedule_open_3,
      },
      {
        day: 3,
        end: form.schedule_close_4,
        start: form.schedule_open_4,
      },
      {
        day: 4,
        end: form.schedule_close_5,
        start: form.schedule_open_5,
      },
      {
        day: 5,
        end: form.schedule_close_6,
        start: form.schedule_open_6,
      },
      {
        day: 6,
        end: form.schedule_close_7,
        start: form.schedule_open_7,
      },
    ];
    return formattedForm;
  }

  private setHours(response) {
    this.form.controls.schedule_open_1.setValue(response.hours[0].start);
    this.form.controls.schedule_close_1.setValue(response.hours[0].end);
    this.form.controls.schedule_close_1.touched;
    this.form.controls.schedule_open_1.touched;

    this.form.controls.schedule_open_2.setValue(response.hours[1].start);
    this.form.controls.schedule_close_2.setValue(response.hours[1].end);
    this.form.controls.schedule_close_2.touched;
    this.form.controls.schedule_open_2.touched;

    this.form.controls.schedule_open_3.setValue(response.hours[2].start);
    this.form.controls.schedule_close_3.setValue(response.hours[2].end);
    this.form.controls.schedule_close_3.touched;
    this.form.controls.schedule_open_3.touched;

    this.form.controls.schedule_open_4.setValue(response.hours[3].start);
    this.form.controls.schedule_close_4.setValue(response.hours[3].end);
    this.form.controls.schedule_close_4.touched;
    this.form.controls.schedule_open_4.touched;

    this.form.controls.schedule_open_5.setValue(response.hours[4].start);
    this.form.controls.schedule_close_5.setValue(response.hours[4].end);
    this.form.controls.schedule_close_5.touched;
    this.form.controls.schedule_open_5.touched;

    this.form.controls.schedule_open_6.setValue(response.hours[5].start);
    this.form.controls.schedule_close_6.setValue(response.hours[5].end);
    this.form.controls.schedule_close_6.touched;
    this.form.controls.schedule_open_6.touched;

    this.form.controls.schedule_open_7.setValue(response.hours[6].start);
    this.form.controls.schedule_close_7.setValue(response.hours[6].end);
    this.form.controls.schedule_close_7.touched;
    this.form.controls.schedule_open_7.touched;
  }

  private setMedia(response) {
    this.form.controls.photo_1.setValue(response.images["1"]);
    this.form.controls.photo_2.setValue(response.images["2"]);
    this.form.controls.photo_3.setValue(response.images["3"]);
    this.form.controls.photo_4.setValue(response.images["4"]);
    this.form.controls.photo_5.setValue(response.images["5"]);
    this.form.controls.photo_1.touched;
    this.form.controls.photo_2.touched;
    this.form.controls.photo_3.touched;
    this.form.controls.photo_4.touched;
    this.form.controls.photo_5.touched;
    if (response.video) {
      this.form.controls.video_1.setValue(response.video);
      this.form.controls.video_1.touched;
    }
  }

  private formMedia() {
    let mediaFormData: FormData = new FormData();

    if (this.form.get("video_1").value !== null) {
      mediaFormData.append("video_1", this.form.get("video_1").value);
    }
    if (typeof this.form.get("photo_1").value != "string") {
      mediaFormData.append("photo_1", this.form.get("photo_1").value);
    }
    if (typeof this.form.get("photo_2").value != "string") {
      mediaFormData.append("photo_2", this.form.get("photo_2").value);
    }
    if (typeof this.form.get("photo_3").value != "string") {
      mediaFormData.append("photo_3", this.form.get("photo_3").value);
    }
    if (typeof this.form.get("photo_4").value != "string") {
      mediaFormData.append("photo_4", this.form.get("photo_4").value);
    }
    if (typeof this.form.get("photo_5").value != "string") {
      mediaFormData.append("photo_5", this.form.get("photo_5").value);
    }
    return mediaFormData;
  }

  public async editCompany() {
    const companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      await this.companyService.putCompanyInfo(
        companyId,
        this.formGeneralInfoData()
      );
      if (typeof this.form.get("file").value != "string") {
        await this.companyService.putMediaToCompany(
          this.formMedia(),
          companyId
        );
      }
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: "",
            title: this.translate.instant("company.general.success_put"),
            type: "alert",
          },
        })
      );
      this.goBack();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  ngOnDestroy() {
    // this.form.get("is_business_group").valueChanges.
  }
}
